import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  totalRevenue: "0.00",
  totalExpenses: "0.00",
  netProfit: "0.00",
  pendingSalaries: "0.00",
  totalDrivers: 0,
  dashboardSummary: {},
  loading: false,
  error: false,
  errorMessage: "",
};

const DashboardReducer = createSlice({
  name: "adminDashboard",
  initialState,
  reducers: {
    setDashboardData(state, action) {
      const data = action.payload;
      
      state.totalRevenue = data.total_revenue;
      state.totalExpenses = data.total_expenses;
      state.netProfit = data.net_profit;
      state.pendingSalaries = data.pending_salaries;
      state.totalDrivers = data.total_drivers;
      state.dashboardSummary = data.dashboard_summary;
      state.loading = false;
      state.error = false;
    },
    loadingDashboard(state, action) {
      state.loading = action.payload;
    },
    dashboardError(state, action) {
      state.error = true;
      state.errorMessage = action.payload;
      state.loading = false;
    },
    clearDashboardError(state) {
      state.error = false;
      state.errorMessage = "";
    },
  },
});

export const {
  setDashboardData,
  loadingDashboard,
  dashboardError,
  clearDashboardError,
} = DashboardReducer.actions;

export default DashboardReducer.reducer;
